import {useOutletContext} from "react-router-dom";

import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";
import {PermitExtensionService} from "permitextension/service";
import {permit_extension_view_adapter} from "permitextension/model";

import {PermitExtensionFeesContent, PermitExtensionFeesSummary} from ".";
import {Spinner} from "base/shared/components";
import Stack from "@mui/material/Stack";

const PermitExtensionFeesStep = () => {
    const {extension, isStepEditable} = useOutletContext();
    const {handleErrors} = useErrors();

    const navigate = useNavigateWithReload();

    const handleFormSubmit = updatedExtension => {
        PermitExtensionService.update(permit_extension_view_adapter(updatedExtension))
            .then(updatedPermit => {
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    return extension.types?.length ? (
        <Stack spacing={1}>
            <PermitExtensionFeesContent
                extension={extension}
                isStepEditable={isStepEditable}
                onFormSubmit={handleFormSubmit}
            />
            <PermitExtensionFeesSummary extension={extension} />
        </Stack>
    ) : (
        <Spinner />
    );
};

export default PermitExtensionFeesStep;
